import { render, staticRenderFns } from "./CustomerCartDetailProduct.vue?vue&type=template&id=0a2c683d&scoped=true"
import script from "./CustomerCartDetailProduct.vue?vue&type=script&lang=js"
export * from "./CustomerCartDetailProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2c683d",
  null
  
)

export default component.exports